// Test IDs for KIKI landing page + admin
export const KIKI = {
  header: 'kiki-header',
  logo: 'kiki-logo',
  navHome: 'nav-home',
  navProgrammes: 'nav-programmes',
  navManifesto: 'nav-manifesto',
  navOutcomes: 'nav-outcomes',
  navFaq: 'nav-faq',
  navContact: 'nav-contact',
  navMentors: 'nav-mentors',
  navFees: 'nav-fees',
  themeToggle: 'theme-toggle',
  ctaEnquire: 'cta-enquire',
  ctaBookSeat: 'cta-book-seat',
  ctaEnquireHero: 'cta-enquire-hero',
  ctaEnquireSticky: 'cta-enquire-sticky',
  hero: 'hero-section',
  heroTitle: 'hero-title',
  marquee: 'marquee-section',
  manifesto: 'manifesto-section',
  programmes: 'programmes-section',
  programmeCard1: 'programme-tool-die',
  programmeCard2: 'programme-mechatronics',
  programmeCard3: 'programme-precision',
  spotlight: 'spotlight-section',
  mentors: 'mentors-section',
  mentorCard: 'mentor-card',
  mentorsCta: 'mentors-cta',
  fees: 'fees-section',
  feePlan: 'fee-plan',
  feePlanCta: 'fee-plan-cta',
  testimonials: 'placement-partners-section',
  outcomes: 'outcomes-section',
  faq: 'faq-section',
  faqItem: 'faq-item',
  contact: 'contact-section',
  newsletterInput: 'newsletter-input',
  newsletterSubmit: 'newsletter-submit',
  footer: 'footer',
};

export const ENQ = {
  modal: 'enquiry-modal',
  close: 'enquiry-close',
  step1Form: 'enquiry-step1-form',
  inputName: 'enquiry-name',
  inputEmail: 'enquiry-email',
  inputPhone: 'enquiry-phone',
  inputProgramme: 'enquiry-programme',
  inputQualification: 'enquiry-qualification',
  inputCity: 'enquiry-city',
  inputMessage: 'enquiry-message',
  sendOtpBtn: 'enquiry-send-otp',
  step2Form: 'enquiry-step2-form',
  inputOtp: 'enquiry-otp',
  verifyBtn: 'enquiry-verify',
  resendBtn: 'enquiry-resend',
  successView: 'enquiry-success',
  successClose: 'enquiry-success-close',
};

export const ADMIN = {
  loginForm: 'admin-login-form',
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginSubmit: 'admin-login-submit',
  loginError: 'admin-login-error',
  dashboard: 'admin-dashboard',
  logout: 'admin-logout',
  statsTotal: 'admin-stat-total',
  statsNew: 'admin-stat-new',
  statsConverted: 'admin-stat-converted',
  statsSubs: 'admin-stat-subs',
  enquiriesTable: 'admin-enquiries-table',
  enquiryRow: 'admin-enquiry-row',
  filterAll: 'admin-filter-all',
  filterNew: 'admin-filter-new',
  filterContacted: 'admin-filter-contacted',
  filterConverted: 'admin-filter-converted',
  searchInput: 'admin-search-input',
  statusSelect: 'admin-status-select',
  deleteBtn: 'admin-delete-btn',
  tabEnquiries: 'admin-tab-enquiries',
  tabNewsletter: 'admin-tab-newsletter',
  tabMessages: 'admin-tab-messages',
};
